import { MessageCircle, X } from "lucide-react";
import { cn } from "@/lib/cn";
import { useSession } from "@/store/session-store";

export function Launcher() {
  const open = useSession((s) => s.open);
  const setOpen = useSession((s) => s.setOpen);
  const position = useSession((s) => s.branding?.position ?? "bottom-right");
  const unread = useSession((s) =>
    open
      ? 0
      : s.messages.filter(
          (m) => m.direction === "outbound" && m.status !== "read",
        ).length,
  );

  return (
    <button
      type="button"
      onClick={() => setOpen(!open)}
      aria-label={open ? "Fechar chat" : "Abrir chat"}
      className={cn(
        "fixed z-[2147483646] h-14 w-14 rounded-full shadow-lg flex items-center justify-center",
        "transition-transform active:scale-95 hover:scale-105",
        "bg-cz-primary text-cz-on-primary",
        position === "bottom-right" ? "right-6 bottom-6" : "left-6 bottom-6",
      )}
    >
      {open ? (
        <X className="h-6 w-6" />
      ) : (
        <div className="relative">
          <MessageCircle className="h-6 w-6" />
          {unread > 0 && (
            <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center">
              {unread > 9 ? "9+" : unread}
            </span>
          )}
        </div>
      )}
    </button>
  );
}
